import { Saga } from '@redux-saga/types'
import { all } from 'redux-saga/effects'
import watchUser from './user'
import watchInvoices from './invoices'

export const rootSaga: Saga<Generator[]> = function* (): Generator {
  yield all([watchUser(), watchInvoices()])
}
